module.exports = __webpack_public_path__ + "img/9788991931107.a8e42dfd.jpg";